import { RLBaseService } from "./rl-base-service";
import * as Models from "../ts/rlAdmin.models";
import { EntityService } from "./entity-service";
import { ContactService } from "./contact-service";
import { ContractService } from "./contract-service";

export class ContractSharedDataService {
    
        static $inject = ["$q", "contractService", "entityService", "contactService"];
    
        contract: Models.IEntityCharDataPair;
        contractPromise: ng.IPromise<Models.IEntityCharDataPair>;
    
        contractAssets: Models.AdvancedSearchResult;
        assetPromise: ng.IPromise<Models.AdvancedSearchResult>;
    
        contractStatus: Models.IEntityStatus;
        contractStatusPromise: ng.IPromise<Models.IEntityStatus>;
    
        constructor(private $q: ng.IQService, private contractService: ContractService,
            private entityService: EntityService, private contactService: ContactService) {
            this.contractAssets = null;
            this.contract = null;
            this.contractStatus = null;
        }
    
        RefreshAssets(contractID: string, pagingOptions?: Models.IPagingOptions): ng.IPromise<any> {
            if (this.assetPromise == null) {
                this.assetPromise = this.contractService.getContractAssets(contractID, pagingOptions);
                this.assetPromise
                    .then((result) => {
                        this.contractAssets = result;
                    })
                    .finally(() => {
                        this.assetPromise = null;
                    });
            }
            return this.assetPromise || this.$q.when(this.contractAssets);
        }
    
        RefreshContract(contractID: string): ng.IPromise<any> {
            if (this.contractPromise == null) {
                this.contractPromise = this.entityService.getEntity(contractID);
                this.contractPromise
                    .then((result) => {
                        this.contract = result;
                    })
                    .finally(() => {
                        this.contractPromise = null;
                    });
            }
            return this.contractPromise || this.$q.when(this.contract);
        }
    
        RefreshContractStatus(contractID: string): ng.IPromise<any> {
            if (this.contractStatusPromise == null) {
                this.contractStatusPromise = this.entityService.getEntityStatus(contractID);
                this.contractStatusPromise
                    .then((result) => {
                        this.contractStatus = result;
                    })
                    .finally(() => {
                        this.contractStatusPromise = null;
                    });
            }
            return this.contractStatusPromise || this.$q.when(this.contractStatus);
        }
    }